export default __webpack_public_path__ + "static/media/img-connect-wallet.fe346a6e.png";